import { useBulkCollectionsFilterShallowStore } from '../../../../../store/bulk-collections-filter-store';
import { UseTokenPaginationReturn, useTokenPagination } from '../../../common/hooks/use-token-pagination';
import { useBulkCollectionsQueryBase, DEFAULT_PAGE_SIZE } from './use-bulk-collections-query-base';

export const useBulkCollectionsPagination = ({ enabled }: { enabled: boolean }): UseTokenPaginationReturn => {
  const { balanceType, searchValue } = useBulkCollectionsFilterShallowStore('balanceType', 'searchValue');

  return useTokenPagination({
    enabled,
    filterKey: `${searchValue}|${balanceType.join(',')}`,
    defaultPageSize: DEFAULT_PAGE_SIZE,
    useQuery: useBulkCollectionsQueryBase,
  });
};
